import styled from 'styled-components';
import { COLORS } from '../../styles/variables';

// eslint-disable-next-line import/prefer-default-export
export const StyledDealerName = styled.span`
  color: ${COLORS.grey70};
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  font-family: 'Audi Type';
  .italic {
    font-style: italic;
  }
`;
